import React from "react";
import styled from "styled-components";
import { Form } from "react-bootstrap";

const Input = styled(Form.Control)`
  min-width: 300px;
  background-color: ${props =>
    props.backgroundcolor ? props.backgroundcolor : "#ffffff"};
  border: 1px solid ${props => (props.error ? "#e53935" : "#c1c1c1")};
  padding-top: 0.8rem;
  padding-bottom: 0.7rem;
  border-radius: 7px;
  outline-style: none;
  margin-bottom: 0.5rem;
  padding-left: 1rem;
  height: calc(2em + 0.75rem + 2px);
  -webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }
  moz-appearance: textfield;
  &::placeholder {
    color: ${props =>
    props.placeholdercolor ? props.placeholdercolor : "#bdbdbd"};
  }
  &:focus {
    border-color: ${props => (props.error ? "#f44336" : "rgb(10, 104, 187)")};
    border-width: 2px;
    background-color: ${props =>
    props.backgroundcolor ? props.backgroundcolor : "#f1f9ff"};
  }
  @media (max-width: 768px) {
    width: 100%;
  }

  @media (max-width: 380px) {
    min-width: 0;
  }
`;
const Label = styled(Form.Label)`
  color: #074f8c;
  font-weight: bold;
  font-size: 1.0625rem;
  display: block;
  margin-bottom: 0.2rem;
  font-size: 1rem;
`;

const Field = props => {
  return (
    <div
      style={{
        position: "relative",
        width: props.containerWidth ? props.containerWidth : "auto"
      }}
    >
      <Label
        htmlFor={props.id ? props.id : null}
        className={props.labelClass ? props.labelClass : ""}
      >
        {props.label}
      </Label>
      <Input
        type={props.type ? props.type : "text"}
        name={props.name}
        backgroundcolor={props.backgroundcolor ? props.backgroundcolor : ""}
        placeholdercolor={props.placeholdercolor ? props.placeholdercolor : ""}
        pattern={props.pattern ? props.pattern : null}
        error={props.error ? props.error : null}
        style={props.style ? props.style : null}
        maxLength={props.maxLength ? props.maxLength : null}
        title={props.title ? props.title : ""}
        placeholder={props.placeholder ? props.placeholder : ""}
        aria-label={props.ariaLabel ? props.ariaLabel : null}
        aria-required={props.ariaRequired ? props.ariaRequired : null}
        className={`${props.className ? props.className : null} ${
          props.errorCondition ? "is-invalid" : ""
          }`}
        id={props.id ? props.id : null}
        onBlur={props.onBlur ? props.onBlur : null}
        onChange={props.onChange ? props.onChange : null}
        value={props.value ? props.value : ""}
        autoComplete="off"
        disabled={props.disabled ? true : false}
      />
      {props.children}
      {props.errorCondition ? (
        <div style={{ width: 300 }} className="invalid-feedback">
          {props.errorMessage}
        </div>
      ) : null}
    </div>
  );
};

export default Field;
